//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: ${({ width = "max-content" }) => width};
    transform: rotate(${({ angle }) => angle});
`;
export const Content = styled.button`
    display: flex;
    height: ${({ height = "max-content" }) => height};
    justify-content: center;
    align-items: center;
    gap: 10px;
    border: 1px solid var(--color-1);
    border-radius: 4px;
    font-weight: 600;
    outline: none;
    background-color: var(--color-1);
    color: var(--color-2);
    width: 100%;
    transition: 0.35s;
    user-select: none;
    & *[data-role="icon"] {
        display: flex;
        justify-content: center;
    }
    & svg path {
        transition: 0.35s;
        fill: var(--color-2);
    }
    &:enabled {
        cursor: pointer;
    }
    /* Size */
    --offset-padding-top-bottom: ${({ offsetPaddingTopBottom = "2px" }) => offsetPaddingTopBottom};
    &, &.default {
        padding: calc(var(--offset-padding-top-bottom) + 12px) 16px;
        font-size: 15px; 
        & .iconify { font-size: 23px; }
    }
    &.medium {
        padding: calc(var(--offset-padding-top-bottom) + 10px) 14px;
        font-size: 14px; 
        & .iconify { font-size: 21px; }
    }
    &.small {
        padding: calc(var(--offset-padding-top-bottom) + 8px) 12px;
        font-size: 13px; 
        & .iconify { font-size: 19px; }
        &.icon {
            padding: 8px 12px;
        }
    }
    &.very-small {
        padding: calc(var(--offset-padding-top-bottom) + 4px) 8px;
        font-size: 13px; 
        & .iconify { font-size: 17px; }
        &.icon {
            padding: 4px 8px;
            width: 36px;
        }
    }
    /* --- */
    /* Variants */
    &, &.primary {
        &:enabled {
            --color-1: var(--purple-2);
            --color-2: var(--light-1);
        }
        &:hover {
            --color-1: var(--purple-3);
        }
        &:active {
            --color-1: var(--purple-1);
        }
        &:disabled {
            --color-1: var(--light-blue-1);
            --color-2: var(--purple-4);
        }
    }
    &.secondary {
        border: 1px solid var(--color-2);
        &:enabled {
            --color-1: var(--light-1);
            --color-2: var(--purple-2);
        }
        &:hover {
            --color-1: var(--light-3);
        }
        &:active {
            --color-1: var(--purple-5);
        }
        &:disabled {
            --color-1: var(--light-1);
            --color-2: var(--purple-4);
        }
    }
    &.terciary {
        &:enabled {
            --color-1: transparent;
            --color-2: var(--purple-2);
        }
        &.dark {
            --color-2: var(--dark-2);
        }
        &:hover {
            --color-1: var(--light-3);
        }
        &:active {
            --color-1: var(--purple-5);
        }
        &:disabled {
            --color-1: transparent;
            --color-2: var(--purple-4);
        }
    }
    &.quaternary {
        &:not(:disabled) {
            &:enabled {
                --color-1: var(--purple-6);
                --color-2: var(--light-1);
            }
            &:hover {
                filter: brightness(150%);
            }
            &:active {
                filter: brightness(150%);
            }
        }
        &:disabled {
            --color-1: var(--light-blue-1);
            --color-2: var(--purple-5);
        }
    }
    &.quintinary {
        border: 1px solid var(--color-2);
        &:enabled {
            --color-1: var(--light-1);
            --color-2: var(--purple-6);
        }
        &:hover {
            --color-1: var(--light-3);
        }
        &:active {
            --color-1: var(--purple-5);
        }
        &:disabled {
            --color-1: var(--light-1);
            --color-2: var(--purple-4);
        }
    }
    &.sixtinary {
        &:enabled {
            --color-1: transparent;
            --color-2: var(--purple-6);
        }
        &:hover {
            --color-1: var(--light-3);
        }
        &:active {
            --color-1: var(--purple-5);
        }
        &:disabled {
            --color-1: transparent;
            --color-2: var(--purple-4);
        }
    }
    &.error {
        --color-2: var(--red-3) !important;
        --color-1: var(--light-1) !important;
    }
    /* --- */
`;